<template>
  <div>
    <t-form labelWidth="100px">
      <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
      <e-collapse title="标题" :expand="false">
        <t-form-item label="标题文本">
          <t-input v-model="attribute.title.text" size="small" :maxcharacter="52"/>
        </t-form-item>
        <t-form-item label="标题大小">
          <t-input-number v-model="attribute.title.textStyle.fontSize" size="small" :min="2" :max="100" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="标题颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" v-model="attribute.title.textStyle.color" size="small"/>
        </t-form-item>
        <t-form-item label="标题位置(X)">
          <e-chart-position v-model="attribute.title.left" :direction="'x'"/>
        </t-form-item>
        <t-form-item label="标题位置(Y)">
          <e-chart-position v-model="attribute.title.top" :direction="'y'"/>
        </t-form-item>
      </e-collapse>
      <e-collapse title="图例" :expand="false">
        <t-form-item label="图例显示">
          <t-switch v-model="attribute.visualMap.show" :label="['开', '关']" size="small"/>
        </t-form-item>
        <t-form-item label="图例位置(X)">
          <e-chart-position v-model="attribute.visualMap.left" :direction="'x'"/>
        </t-form-item>
        <t-form-item label="图例位置(Y)">
          <e-chart-position v-model="attribute.visualMap.top" :direction="'y'"/>
        </t-form-item>
        <t-form-item label="文本颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.visualMap.textStyle.color"/>
        </t-form-item>
      </e-collapse>
      <e-collapse title="路线">
<!--        <t-form-item label="显示">
          <t-switch v-model="attribute.line.show" :label="['显示', '不显示']" size="small"/>
        </t-form-item>-->
        <t-form-item label="路线颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.line.lineStyle.color"/>
        </t-form-item>
<!--        <t-form-item label="弯曲度">
          <t-input-number size="small" v-model="attribute.line.lineStyle.curveness" :min="0" :max="10" :decimal-places="1" :step="0.1"/>
        </t-form-item>-->
        <t-form-item label="终点大小">
          <t-input-number size="small" v-model="attribute.line.endPoint.symbolSize" :min="0" :max="20" :decimal-places="0" :step="1"/>
        </t-form-item>
        <t-form-item label="终点颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.line.endPoint.itemStyle.color"/>
        </t-form-item>
      </e-collapse>
      <e-collapse title="地图" :expand="false">
        <t-form-item label="地图字颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.label.color"/>
        </t-form-item>
        <t-form-item label="地图字大小">
          <t-input-number size="small" v-model="attribute.label.fontSize" :min="4" :max="100" :decimal-places="0"/>
        </t-form-item>
        <t-form-item label="边界线颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.itemStyle.borderColor"/>
        </t-form-item>
        <t-form-item label="区域颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.itemStyle.color"/>
        </t-form-item>
      </e-collapse>
      <e-collapse title="条件配色" :expand="true">
        <t-form-item label="默认颜色">
          <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="attribute.itemStyle.color"/>
        </t-form-item>
        <div style="padding: 0 4px 0 4px;">
          <div v-for="(item,index) in attribute.visualMap.pieces" :key="index" class="conditionItem">
            <div>
              <div class="formLabel">标签</div>
              <div class="formItem">{{item.label}}</div>
            </div>
            <div>
              <div class="formLabel">数值区间</div>
              <div class="formItem">{{'['+(item.gte === undefined? '∞':item.gte)+','+(item.lt === undefined ? '∞':item.lt)+')'}}</div>
            </div>
            <div>
              <div class="formLabel">颜色</div>
              <div class="formItem" style="width: 20px;height: 20px;" :style="{backgroundColor:attribute.color[index]}"></div>
            </div>
            <div style="position: absolute;width: 50px;height: 35px;cursor: pointer;top: 0;right: 0">
              <t-icon name="edit" @click="editPiece(item,index)"/>
              <t-icon style="margin-left: 10px" name="delete" @click="delPiece(index)"/>
            </div>
          </div>
          <t-button block @click="addPiece()" :disabled="attribute.visualMap.pieces.length >= 7">新增条件</t-button>
        </div>
      </e-collapse>
    </t-form>
    <t-dialog header="新增条件配色" v-model:visible="modelShow" @confirm="onConfirm" :zIndex="2000" width="640">
      <div style="height: 100%;overflow: hidden">
        <t-form>
          <t-form-item label="标签">
            <t-input v-model="currPiece.label"/>
          </t-form-item>
          <t-form-item label="数值区间">
            <div style="width: 80px;text-align: center">大于等于</div>
            <t-input-number v-model="currPiece.gte"/>
            <div style="width: 80px;text-align: center">小于</div>
            <t-input-number v-model="currPiece.lt"/>
          </t-form-item>
          <t-form-item label="颜色">
            <t-color-picker :colorModes="['monochrome']" format="HEX" size="small" v-model="currPiece.color"/>
          </t-form-item>
        </t-form>
      </div>
    </t-dialog>
  </div>
</template>

<script>
import EChartPosition from "@/components/designer/e-chart-position";
import CptData from '@/components/element/options/comp/cpt-data'
export default {
  name: "cpt-chart-map-3d-line-option",
  components: {EChartPosition,CptData},
  props: {attribute: Object,cptDataForm:Object,},
  data(){
    return {
      modelShow:false,
      currPiece:{
        label:'',
        gte:0,
        lt:0,
        color:'#000'
      },
      currPieceIndex:null
    }
  },
  methods:{
    onConfirm(){
      if(this.currPiece.gte === null || this.currPiece.gte === ''){
        this.currPiece.gte = undefined
      }
      if(this.currPiece.lt === null || this.currPiece.lt === ''){
        this.currPiece.lt = undefined
      }
      if(this.currPieceIndex !== null){
        const temp = {
          label:this.currPiece.label,
          gte: this.currPiece.gte,
          lt: this.currPiece.lt
        }
        this.attribute.visualMap.pieces.splice(this.currPieceIndex,1,temp)
        if(this.attribute.color[this.currPieceIndex]){
          this.attribute.color[this.currPieceIndex] = this.currPiece.color
        }else{
          this.attribute.color.push(this.currPiece.color)
        }
      }else{
        this.attribute.visualMap.pieces.push(JSON.parse(JSON.stringify(this.currPiece)))
        const index = this.attribute.visualMap.pieces.length - 1
        if(this.attribute.color[index]){
          this.attribute.color[index] = this.currPiece.color
        }else{
          this.attribute.color.push(this.currPiece.color)
        }
      }
      this.modelShow = false
    },
    addPiece(){
      this.currPieceIndex = null
      this.modelShow = true
    },
    editPiece(item, index){
      this.currPieceIndex = index
      this.currPiece.label = item.label
      this.currPiece.gte = item.gte
      this.currPiece.lt = item.lt
      this.currPiece.color = this.attribute.color[index]
      this.modelShow = true
    },
    delPiece(index){
      this.attribute.visualMap.pieces.splice(index,1)
      this.attribute.color.splice(index,1)
    }
  }
}
</script>

<style scoped>
.conditionItem{width: 100%;background: rgba(0,0,0,0.2);padding-top: 6px;line-height: 35px;position: relative;margin-bottom: 4px;}
.formLabel{display: inline-block;width: 100px;text-align: center}
.formItem{display: inline-block;}
</style>
